const CHECK_SELECTION = 'CHECK_SELECTION';
const CHOOSE_Q_TYPE = 'CHOOSE_Q_TYPE';
const CHECK_IF_DONE = 'CHECK_IF_DONE';
const BOUNCE_ON_ERROR = 'BOUNCE_ON_ERROR';
const FINISHED = 'FINISHED';
const REFRESH = 'REFRESH';

export { CHECK_SELECTION, CHOOSE_Q_TYPE, CHECK_IF_DONE, BOUNCE_ON_ERROR, FINISHED, REFRESH };



// WEBPACK FOOTER //
// ./src/actions/types.js